import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { COMPLAINTS_STATUS_DATA, status_edit_list } from '../../students/complaint/enum/complaint.enum';
import StatusCustom from '../../../components/status/statusCustom';
import { ComplaintApi, complaintListFront } from '../../../api/complaint/complaint.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { complaintType, ComplaintTypeApi } from '../../../api/complaint-type/complaint_type.api';
import { complaintReport, ReportApi } from '../../../api/report/Report.api';
import { saveAs } from 'file-saver';
import { alertError } from '../../../components/alert/swal';

const ManageStateComplaintList = () => {
    const { t, i18n } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [search, setSearch] = useState<string>("");
    const [id_complaints_type, set_id_complaints_type] = useState<any>(null);
    const [search_complaint_type, set_search_complaint_type] = useState<string>("");
    const [status, set_status] = useState<string>("");
    const [complaint_type_data, set_complaint_type_data] = useState<any[]>([]);

    const [data, setData] = useState<any[]>([]);
    const [date_range, set_date_range] = useState<string[]>([]);


    const handleChangeDateRange = (date_range_value: string[]) => {
        set_date_range(date_range_value)
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 100, sortable: true, disablePadding: false, align: 'center', label: t("COMPLAINTS_ORDER")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("COMPLAINTS_COMPLAINT_CATEGORY")
        },
        {
            id: "subject_credit", disablePadding: false, align: "center", width: 140, label: t("COMPLAINTS_SUBJECT")
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("COMPLAINTS_SENDER_FULLNAME")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("COMPLAINTS_SUBMITTED_DATE")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 160, class: matches && data.length > 0, label: t("COMPLAINTS_STATUS")
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            complaints_subject,
            complaints_type_name,
            submit_date,
            complaints_status,
            id_complaints,
            submit_full_name

        } =
            objData;

        // subject_no: "BUD32",
        // subject_name: "ปรัชญาพุทธศาสตร์",
        // status: "ACTIVE",
        // create_date: new Date(),
        // create_by: "นางมาริสา มากดีดก"
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: complaints_type_name || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: complaints_subject || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: submit_full_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: submit_date ? moment(submit_date).add(i18n.language === "en" ? 0 : 543, 'year').format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-between items-center'>
                        <span>
                            <StatusCustom
                                disableMaxWidth
                                text={t(`${COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label}`) || ""}
                                type={t(`${COMPLAINTS_STATUS_DATA.find((x) => x.value === complaints_status)?.label}`) || ""}
                            />
                        </span>
                        <span>
                            <OptionsButtonCustom
                                enableEdit={status_edit_list.includes(complaints_status)}
                                enableView
                                onEditClick={() => {
                                    navigate(routeName.cms.complaintSystemDetail.replace(":id", id_complaints))
                                }}
                                onViewClick={() => {
                                    navigate(routeName.cms.complaintSystemDetailView.replace(":id", id_complaints))
                                }}
                            />
                        </span>
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetComplaintType = useCallback(async () => {
        let query: complaintType = {
            page: 1,
            limit: 20
        }
        if (search_complaint_type) query = { ...query, keyword: search_complaint_type }
        await ComplaintTypeApi.getList(query).then((res) => {
            if (res.status < 300) {
                set_complaint_type_data(res.data?.data?.items || [])
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_complaint_type])


    const handleGetData = useCallback(async () => {
        let query: complaintListFront = {
            page: page,
            limit: pageLimit
        }
        if (search) query = { ...query, keyword: search }
        if (id_complaints_type) query = { ...query, id_complaints_type: id_complaints_type?.id_complaints_type }
        if (date_range?.length === 2 && date_range?.every((x) => moment(x).isValid())) {
            query = { ...query, start_date: moment(date_range[0]).format("YYYY-MM-DD") }
            query = { ...query, end_date: moment(date_range[1]).format("YYYY-MM-DD") }
        }
        if (status) query = { ...query, complaints_status: status }
        dispatch(setLoading());
        await ComplaintApi.getListBack(query).then((res) => {
            if (res.status < 300) {
                console.log(res.data)
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, id_complaints_type, date_range, status, search])

    const handleDownloadReport = async () => {
        let query: complaintReport = {}
        if (id_complaints_type) query = { ...query, id_complaints_type: id_complaints_type?.id_complaints_type }
        if (search) query = { ...query, keyword: search }
        if (date_range?.length === 2 && date_range?.every((x) => moment(x).isValid())) {
            query = { ...query, start_date: moment(date_range[0]).format("YYYY-MM-DD") }
            query = { ...query, end_date: moment(date_range[1]).format("YYYY-MM-DD") }
        }
        if (status) query = { ...query, complaints_status: status }
        dispatch(setLoading());
        await ReportApi.complaintReport(query).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
                saveAs(blob_file, t("COMPLAINTS_MANAGE_DATA"))
            }
        }).catch((err) => {
            console.log(err)
            alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetComplaintType();
    }, [handleGetComplaintType])
    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setSearch,
        handleChangeDateRange,
        date_range,
        complaint_type_data,
        id_complaints_type,
        set_id_complaints_type,
        set_search_complaint_type,
        handleDownloadReport,
        set_status,
        status
    }
}

export default ManageStateComplaintList
